"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gatsby = require("gatsby");
var _utils = require("../../utils/utils");
require("../../utils/_variables.css");
// Packages

// Components

// Utils

// Styles

const Link = _styledComponents.default.a.withConfig({
  displayName: "inline__Link",
  componentId: "sc-soizhp-0"
})(["background:", ";border-bottom:", ";color:", ";display:inline;font-size:20px;line-height:28px;padding:0;max-width:100%;text-decoration:none;cursor:pointer;&:hover,&:active{color:", ";text-decoration:none;}&.primary{color:", ";text-decoration:underline;&:hover,&:active{background:", ";color:", ";text-decoration:none;}}&.secondary{color:", ";&:hover,&:active{color:", ";text-decoration:underline;}}&.tertiary{border-bottom:", ";color:", ";&:hover,&:active{border-bottom:", ";color:", ";}}"], props => props.$defaultBackground || "transparent", props => props.$defaultBorder || "none", props => props.$defaultColor || _utils.colors["baltic-blue"].hex, props => props.$activeColor || _utils.colors["pacific-blue"].hex, props => _utils.colors["pacific-blue"].hex || props.$defaultColor, props => _utils.colors["arctic-blue-1"].hex || props.$activeBackground, props => _utils.colors["baltic-blue"].hex || props.$activeColor, props => _utils.colors["baltic-blue"].hex || props.$defaultColor, props => _utils.colors["baltic-blue"].hex || props.$activeColor, props => props.$defaultBorder || `1px dashed ${_utils.colors["pacific-blue"].hex}`, props => _utils.colors["pacific-blue"].hex || props.$defaultColor, props => props.$activeBorder || `1px solid ${_utils.colors["pacific-blue"].hex}`, props => _utils.colors["pacific-blue"].hex || props.$activeColor);
function InlineLink(props) {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Link, Object.assign({}, props.linkAttributes, {
    $activeColor: props.activeColor,
    $defaultColor: props.defaultColor,
    $activeBorder: props.activeBorder,
    $defaultBorder: props.defaultBorder,
    $activeBackground: props.activeBackground,
    $defaultBackground: props.defaultBackground,
    className: `${props.linkClass && props.linkClass} ${props.type} inline-link`,
    as: props.linkAttributes && props.linkAttributes.href ? "a" : _gatsby.Link
  }), props.linkText));
}
InlineLink.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "InlineLink",
  "props": {
    "type": {
      "defaultValue": {
        "value": "\"primary\"",
        "computed": false
      },
      "description": "Link Type",
      "type": {
        "name": "enum",
        "value": [{
          "value": "\"primary\"",
          "computed": false
        }, {
          "value": "\"secondary\"",
          "computed": false
        }, {
          "value": "\"tertiary\"",
          "computed": false
        }, {
          "value": "\"custom\"",
          "computed": false
        }]
      },
      "required": false
    },
    "activeColor": {
      "description": "Text color of link when link is active (clicked / hovered / pressed)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "activeBackground": {
      "description": "Background color of link when link is active (clicked / hovered / pressed)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "defaultBackground": {
      "description": "Default background color of link",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "defaultBorder": {
      "description": "Default border (bottom) of link, eg. 1px solid blue",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "activeBorder": {
      "description": "Border (bottom) when link is active (clicked / hovered / pressed)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "linkText": {
      "description": "Link text",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "defaultColor": {
      "description": "Default text color of link",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "linkAttributes": {
      "description": "Link Attributes e.g. { to: \"/\", target: \"_blank\"}",
      "type": {
        "name": "shape",
        "value": "PropTypes.shape()",
        "computed": true
      },
      "required": false
    },
    "linkClass": {
      "description": "Custom link class",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};
var _default = InlineLink;
exports.default = _default;
InlineLink.propTypes = {
  /**
   * Text color of link when link is active (clicked / hovered / pressed)
   */
  activeColor: _propTypes.default.string,
  /**
   * Background color of link when link is active (clicked / hovered / pressed)
   */
  activeBackground: _propTypes.default.string,
  /**
   *  Default background color of link
   */
  defaultBackground: _propTypes.default.string,
  /**
   * Default border (bottom) of link, eg. 1px solid blue
   */
  defaultBorder: _propTypes.default.string,
  /**
   * Border (bottom) when link is active (clicked / hovered / pressed)
   */
  activeBorder: _propTypes.default.string,
  /**
   * Link text
   */
  linkText: _propTypes.default.string.isRequired,
  /**
   * Default text color of link
   */
  defaultColor: _propTypes.default.string,
  /**
   * Link Type
   */
  type: _propTypes.default.oneOf(["primary", "secondary", "tertiary", "custom"]),
  /**
   * Link Attributes e.g. { to: "/", target: "_blank"}
   */
  linkAttributes: _propTypes.default.shape(),
  /**
   * Custom link class
   */
  linkClass: _propTypes.default.string
};
InlineLink.defaultProps = {
  type: "primary"
};